import JSZip from 'jszip';
import {downloadZIP} from './download';

/**
 * Interface to jszip
 */
export default class Zip {

    /**
     * Constructor
     */
    constructor(){
        this.jszip =  JSZip();
    }


    /**
     * Add a file
     * @param content The file content
     * @param name The file name
     */
    add(content, name){

        const blob = new Blob([content]);

        this.jszip.file(name, blob);

    }

    async addURL(url){

        const res = await axios.get(url, {
            responseType: 'blob'
        });

        // Get filename
        const contentDisposition = res.headers['content-disposition'];
        const match = (/filename="(.*)"/g).exec(contentDisposition);
        const filename = match[1];


        await this.add(res.data, filename);

    }


    /**
     * Return the zipped file
     */
    async zip(){

        return await this.jszip.generateAsync({type: "blob"});

    }


    async download(name){

        const zip = await this.zip();

        await downloadZIP(zip, name);
    }


}